import React from 'react';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { AppText } from '@/components/ui/AppText';
import { formatNumber, formatPrice } from '@/lib/i18n/format';
import { useLocale } from '@/lib/i18n/LocaleProvider';

/** Live budget bar: volt while affordable, red when over. */
export function BudgetMeter({
  spent,
  budget,
  pickedCount,
  squadSize,
}: {
  spent: number;
  budget: number;
  pickedCount: number;
  squadSize: number;
}) {
  const { t } = useTranslation();
  const { numeralOptions } = useLocale();
  const remaining = Math.round((budget - spent) * 10) / 10;
  const over = remaining < 0;
  const ratio = budget > 0 ? Math.min(spent / budget, 1) : 0;

  return (
    <View className="gap-2">
      <View className="flex-row items-center justify-between">
        <AppText variant="caption" weight="semibold" className={over ? 'text-loss' : 'text-volt'}>
          {over
            ? t('fantasy.builder.overBudget', {
                amount: formatPrice(Math.abs(remaining), numeralOptions),
              })
            : t('fantasy.builder.remaining', {
                amount: formatPrice(remaining, numeralOptions),
              })}
        </AppText>
        <AppText variant="caption" weight="medium" tabular>
          {t('fantasy.builder.picked', {
            count: formatNumber(pickedCount, numeralOptions),
            total: formatNumber(squadSize, numeralOptions),
          })}
        </AppText>
      </View>
      <View className="h-2 overflow-hidden rounded-full bg-surface-2">
        <View
          className={`h-full rounded-full ${over ? 'bg-loss' : 'bg-volt'}`}
          style={{ width: `${Math.max(ratio * 100, 2)}%` }}
        />
      </View>
    </View>
  );
}
